import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentToken } from '../../../app.config';
import { Price, StorePricePayload } from '../../models/catalog/price.model';

/**
 * Polymorphic price service. Append-only: only `create` and `delete` are
 * exposed. `UpdatePriceRequest` exists server-side but is intentionally not
 * surfaced in the FE — the model is append-only.
 */
@Injectable({ providedIn: 'root' })
export class PriceService {
  #http = inject(HttpClient);
  #apiUrl = inject(EnvironmentToken).apiUrl;

  createPrice(payload: StorePricePayload): Observable<{ data: Price }> {
    return this.#http.post<{ data: Price }>(
      `${this.#apiUrl}/api/admin/catalog/prices`,
      payload,
    );
  }

  deletePrice(id: number): Observable<unknown> {
    return this.#http.delete(`${this.#apiUrl}/api/admin/catalog/prices/${id}`);
  }
}
